import { NetworkStatus } from '@cbridge-utils/network';
import { IPricingProfileStore, PricingMode, AggregationMethod } from './pricingProfile.interface';

export const pricingProfileInitialState: IPricingProfileStore = {
  data: {},
  networkStatus: NetworkStatus.None,
};

export const PRICING_MODE_LABEL_KEY = {
  [PricingMode.LpFailover]: 'text:entity.pricingProfile.pricingMode.value.lpFailover',
  [PricingMode.SymbolFailover]: 'text:entity.pricingProfile.pricingMode.value.symbolFailover',
  [PricingMode.BasicAggregation]: 'text:entity.pricingProfile.pricingMode.value.basicAggregation',
} as const satisfies Record<PricingMode, string>;

export const AGGREGATION_METHOD_LABEL_KEY = {
  [AggregationMethod.SumVolumes]: 'text:entity.pricingProfile.aggregationMethod.value.sumVolumes',
  [AggregationMethod.SeparateLP]: 'text:entity.pricingProfile.aggregationMethod.value.separateLp',
} as const satisfies Record<AggregationMethod, string>;
